import Box from '@mui/material/Box';

export const ContentPlaceholder = () => {
  return (
    <Box component="div" mt={2} mb={2} />
  );
}
